import { HTMLAttributeAnchorTarget } from 'react';

export enum AllowedActionMenuElements {
  Button = 'button',
  Title = 'title',
  Link = 'a',
}

export type BaseOption = {
  /** Adds an hr after the option, for visual separation */
  appendDivider?: boolean;
  content: React.ReactNode;
  id: string;
  isDisabled?: boolean;
  isDestructive?: boolean;
  onClick?: () => void;
  description?: React.ReactNode;
  /** Component to wrap option, ie. a Tooltip for disabled buttons/links */
  Wrapper?: React.FunctionComponent<React.PropsWithChildren<unknown>>;
};

export type ButtonOption = BaseOption & {
  as: AllowedActionMenuElements.Button;
};

export type LinkOption = BaseOption & {
  as: AllowedActionMenuElements.Link;
  href?: string;
  target?: HTMLAttributeAnchorTarget;
  isExternalLink?: boolean;
};

export type TitleOption = BaseOption & {
  as: AllowedActionMenuElements.Title;
};

export type ActionMenuOption = ButtonOption | LinkOption | TitleOption;

export type ActionMenuOptionProps = {
  href?: string;
  isDisabled: Required<BaseOption['isDisabled']>;
  onClick: (() => void) | undefined;
  rel?: any;
  tabIndex: number;
  target?: any;
};

export enum MENU_ALIGNMENTS {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum MENU_DIRECTIONS {
  BOTTOM = 'bottom',
  TOP = 'top',
}
